import {
  getLiteralLanguage,
  getLiteralType,
  getLiteralValue,
  IStringQuad,
  quadToStringQuad,
  stringQuadToQuad,
  stringToTerm,
  termToString,
} from './lib/TermUtil';
export {
  getLiteralLanguage,
  getLiteralType,
  getLiteralValue,
  IStringQuad,
  quadToStringQuad,
  stringQuadToQuad,
  stringToTerm,
  termToString,
};
